"use client";

import React from "react";
import { FaCheckCircle } from "react-icons/fa";

// components
import Modal from "@/shared/Modal";
import Button from "@/shared/Button";

// helpers
import { COMPLETED_STEPS } from "./constants";
import useUserProfile from "@/hooks/useUserProfile";
import { useDimension } from "@/hooks/useDimensions";

// interfaces
import { ICompletedStepModal } from "./ICompletedStepModal";

// assets
import styles from "@/assets/styles/components/Modals/completed-step-modal.module.scss";

function CompletedStepModal(props: ICompletedStepModal) {
  const {
    open,
    type = null,
    spaceSlug = null,
    locationSlug = null,
    campaignId = null,
    handleCloseModal,
    onClose,
    ...restProps
  } = props;

  const stepData = COMPLETED_STEPS.find(step => step.stepKey === type);

  const { data } = useUserProfile();

  const [width] = useDimension();

  const isMobile = width < 767;

  // methods
  const handleCloseClick = () => {
    onClose && onClose();
    handleCloseModal();
  }

  const footerButtonProps = () => {
    switch (type) {
      case "create-campaign":
        return { to: "/go-search" };
      case "create-campaign-add-space":
      case "add-space":
        return { to: `/location/${locationSlug}/space/${spaceSlug}#get-availability` };
      case "option-space":
        return { to: `/campaign/${campaignId}/planner` };
      default:
        return {};
    }
  }

  // renders
  if (!stepData) {
    return;
  }

  const renderTitle = () => (
    <div className={styles["locl-completed-step-modal__title"]}>
      <FaCheckCircle className={styles["locl-completed-step-modal__title__icon"]} />
      <div className={styles["locl-completed-step-modal__title__text"]}>
        {stepData.title}
      </div>
    </div>
  )

  const renderFooter = () => (
    <div className={styles["locl-completed-step-modal__footer"]}>
      {
        !!stepData.buttonText && (
          <Button
            {...footerButtonProps()}
            onClick={handleCloseModal}
            data-testid="locl-completed-step-modal-button-cta"
          >
            {stepData.buttonText}
          </Button>
        )
      }
      <button className={styles["locl-completed-step-modal__footer__button_close"]} onClick={handleCloseClick} data-testid="locl-completed-step-modal-button-close">
        Close
      </button>
    </div>
  )


  return (<>
    <Modal
      centered
      open={open}
      className={styles["locl-completed-step-modal"]}
      { ...restProps }
      title={renderTitle()}
      footer={renderFooter()}
      onCancel={handleCloseClick}
      zIndex={999999}
      closable={isMobile}
      maskClosable={false}
    >
      {
        open && (
          <div className={styles["locl-completed-step-modal__body"]} data-testid="locl-completed-step-modal-body">
            <div className={styles["locl-completed-step-modal__description"]} data-testid="locl-completed-step-modal-title">
              {stepData.description(data?.firstName as string)}
            </div>
            {
              stepData.video && (
                <video
                  className={styles["locl-completed-step-modal__video"]}
                  playsInline
                  controls
                  preload="none"
                  autoPlay
                >
                  <source
                    className="embed-responsive-item"
                    src={stepData.video}
                    type="video/mp4"
                    data-testid="locl-completed-step-modal-video-source"
                  />
                </video>
              )
            }
            
          </div>
        )
      }
    </Modal>
  </>);
}

export default CompletedStepModal;
